import { Pipe, PipeTransform } from '@angular/core';
import { ProjectLanguage } from '../../firestore-models/project-language';
import { Descs } from '../../firestore-models/descs';

@Pipe({
  name: 'multiDesc',
  standalone: false,
})
export class MultiDescPipe implements PipeTransform {

  transform(values: Descs, languages: Array<ProjectLanguage>,currentLang: string = 'ja'): string {
    let desc: string = '';
    if (!!values && !!values.desc_details && !!values.desc_details.length) {
      const language = languages.find(lang => lang.lang_code === currentLang);//#216 日本語固定になっているので、admin_lang_modeに従って出し分ける
      // const language = languages[0];
      if (language) {
        for (const value of values.desc_details) {
          if (language.lang_code === value.lang_code) {
            desc = value.desc!;
            break;
          }
        }
      }
    }
    return desc;
  }

}
